module.exports = __webpack_public_path__ + "img/my.818e3427.svg";